import { render, staticRenderFns } from "./CategoryCardWithBackground.vue?vue&type=template&id=6edb2186&scoped=true"
import script from "./CategoryCardWithBackground.vue?vue&type=script&lang=js"
export * from "./CategoryCardWithBackground.vue?vue&type=script&lang=js"
import style0 from "./CategoryCardWithBackground.vue?vue&type=style&index=0&id=6edb2186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb2186",
  null
  
)

export default component.exports